import { BaseModel } from './BaseModel';

export class RunTask extends BaseModel {
    public id = '';
    public taskId?: string;
    public sequenceId = -1;
    public action = '';
    public payload?: string;
    public status = '';
    public message?: string;
    public messageParams: Record<string, unknown> = {};
    public backupId?: string;
    public startedAt?: string;
    public finishedAt?: string;
    public createdAt = '';
    public updatedAt = '';
}
